import type { IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import type { AppIconColor } from '../../app-icon'

import { faCopy, faCheck } from '@fortawesome/pro-regular-svg-icons'

export interface IconCopyProps {
  value: string | number
  tooltip?: string
}

interface IconCopyReturn {
  copied: Ref<boolean>
  icon: ComputedRef<IconDefinition>
  color: ComputedRef<AppIconColor>
  tooltipText: ComputedRef<string>
  setCopy: () => Promise<void>
}

export const useIconCopy = (props: IconCopyProps): IconCopyReturn => {
  const copied = ref(false)

  const icon = computed(() => copied.value ? faCheck : faCopy)
  const color = computed(() => copied.value ? 'emerald-600' : 'blue-600')
  const tooltipText = computed(() => {
    if (!props.tooltip) return ''
    return copied.value ? 'Copied' : props.tooltip
  })

  const setCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(String(props.value))
      copied.value = true
      const id = setTimeout(() => {
        copied.value = false
        clearTimeout(id)
      }, 2000)
    }
    catch (error) {
      console.error('Failed to copy to clipboard:', error)
    }
  }

  return {
    copied,
    icon,
    color,
    tooltipText,
    setCopy,
  }
}
